module.exports = __webpack_public_path__ + "img/product-wrap-bg-hen.bb0e65b3.png";